import { useRef, useEffect, useState } from "react";
import Select from 'react-select';
import { ddStyles } from "../utils/CommonStyles.js";

let surveyOptions = [];
function CompanySurveyTableRow({ index, surveyList, handleSubmit, setError, t, setAdd, setEdit, oddIdx }) {
    const [appSurveyKey, setAppSurveyKey] = useState(0);
    const [surveySelected, setSurveySelected] = useState({ name: "appSurveyKey", label: "", value: 0 });
    const [surveyLoaded, setSurveyLoaded] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);
    const shouldBeReviewedRef = useRef(null);
    const [isShouldBeReviewed, setIsShouldBeReviewed] = useState(false);
    const shareManuallyRef = useRef(null);
    const [isShareManually, setIsShareManually] = useState(false);
    const addedBySelfRef = useRef(null);
    const [addedBySelf, setAddedBySelf] = useState(true);
    const addedByBuyerRef = useRef(null);
    const [addedByBuyer, setAddedByBuyer] = useState(false);

    useEffect(() => {
        setSurveyValues(surveyList);
    }, [surveyList]);

    function setSurveyValues(surveyObj) {
        let surveyValue = {};
        surveyOptions = [];
        surveyOptions.push({ label: "", value: 0 });
        if (surveyObj && surveyObj.length > 0) {
            surveyObj.map((aSurvey, idx) => {
                surveyValue.label = aSurvey.surveyDisplayName;
                surveyValue.value = aSurvey.surveyKey;
                surveyOptions.push(surveyValue);
                if (idx == 0) {
                    setSurveySelected({ ...surveySelected, label: (aSurvey.surveyDisplayName), value: aSurvey.surveyKey });
                    setAppSurveyKey(aSurvey.surveyKey);
                }
                surveyValue = {};
            });
        }
        setSurveyLoaded(true);
    }

    const surveyHandler = (selectedOption, action) => {
        let selectedAppSurveyKey = selectedOption ? selectedOption.value : 0;
        let selectedSurveyName = selectedOption ? selectedOption.label : "";
        setAppSurveyKey(selectedAppSurveyKey);
        setSurveySelected({ ...surveySelected, label: selectedSurveyName, value: selectedAppSurveyKey });
    }

    const onResponseChange = (event) => {
        //console.log(event.target + "  " + event.target.name + " " + event.target.checked);
        const { name, id } = event.target;
        //event.preventDefault();
        //event.stopPropagation();
        if (name.startsWith("addedBySelf_")) {
            setAddedBySelf(event.target.checked);
        } else if (name.startsWith("addedByBuyer_")) {
            setAddedByBuyer(event.target.checked);
        } else if (name.startsWith("shouldBeReviewed_")) {
            setIsShouldBeReviewed(event.target.checked);
        } else if (name.startsWith("shareManually_")) {
            setIsShareManually(event.target.checked);
        }
    }

    function submitComplete() {
        setIsSubmit(false);
        setIsShouldBeReviewed(false);
        setIsShareManually(false);
        setAddedBySelf(true);
        setAddedByBuyer(false);
    }

    function submitRow() {
        setError("");
        setIsSubmit(true);

        if (!appSurveyKey || appSurveyKey === 0) {
            setError(t("error.survey.Reqd"));
            setIsSubmit(false);
        } else {
            let initialValues = {
                appSurveyKey: appSurveyKey,
                addedBySelf: addedBySelfRef.current.checked,
                addedByBuyer: addedByBuyerRef.current.checked,
                shouldBeReviewed: shouldBeReviewedRef.current.checked,
                shareManually: shareManuallyRef.current.checked,
            };
            handleSubmit(1, initialValues, submitComplete);
        }

    }
    function submitCancel() {
        setError("");
        setAdd(false);
        setEdit(false);
        setIsSubmit(false);
        setIsShouldBeReviewed(false);
        setIsShareManually(false);
        setAddedBySelf(true);
        setAddedByBuyer(false);
    }
    return (
        <tr key={index}>
            <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                {surveyLoaded ? <Select
                    name="appSurveyKey"
                    options={surveyOptions}
                    onChange={surveyHandler}
                    placeholder={""}
                    value={surveySelected}
                    isSearchable={true}
                    isClearable={true}
                    className="myselect"
                    inputId="appSurveyKey-input"
                    styles={ddStyles}
                />
                    : <></>}
            </td>
            <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                <input type="checkbox" className="mycheckbox"
                    ref={addedBySelfRef}
                    name={"addedBySelf_0"}
                    id={"addedBySelf_0"}
                    defaultChecked={true}
                    checked={addedBySelf}
                    onChange={onResponseChange}
                />
            </td>
            <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                <input type="checkbox" className="mycheckbox"
                    ref={addedByBuyerRef}
                    name={"addedByBuyer_0"}
                    id={"addedByBuyer_0"}
                    defaultChecked={false}
                    checked={addedByBuyer}
                    onChange={onResponseChange}
                />
            </td>
            <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                <input type="checkbox" className="mycheckbox"
                    ref={shouldBeReviewedRef}
                    name={"shouldBeReviewed_0"}
                    id={"shouldBeReviewed_0"}
                    defaultChecked={false}
                    checked={isShouldBeReviewed}
                    onChange={onResponseChange}
                />
            </td>
            <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                <input type="checkbox" className="mycheckbox"
                    ref={shareManuallyRef}
                    name={"shareManually_0"}
                    id={"shareManually_0"}
                    defaultChecked={false}
                    checked={isShareManually}
                    onChange={onResponseChange}
                />
            </td>
            <td className={oddIdx ? "list-td col odd" : "list-td col even"}>{t("page.active")}</td>
            <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                <div id="submit-spinner"
                    className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
                >
                </div>
                <button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitRow())}>{t("page.submit")}</button>
                <button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitCancel())}>{t("page.cancel")}</button></td>
        </tr>
    )

}
export default CompanySurveyTableRow;